import React from "react";
import { HStack, Typography } from "../primitives";

const STATUS_CHIP_CLASS_BY_SIMILARITY_TYPE = {
  match: "common__status_chip__success",
  differs: "common__status_chip__error",
};

const BcrReviewFieldRow = ({ label, value, notAvailableLabel, similarityType, badgeLabel }) => {
  const displayValue = value === null || value === undefined || value === "" ? notAvailableLabel : value;
  const rowClassName = similarityType
    ? `bcr-review__field-row bcr-review__field-row--${similarityType}`
    : "bcr-review__field-row";

  return (
    <div className={rowClassName}>
      <Typography variant="body2" className="bcr-review__field-label">
        {label}
      </Typography>
      <HStack alignItems="flex-start" justifyContent="flex-end" spacing={1} direction="row"
        className="bcr-review__field-value-group">
        <Typography variant="body2" className="bcr-review__field-value">
          {displayValue}
        </Typography>
        {similarityType && (
          <Typography
            component="span"
            variant="caption"
            className={STATUS_CHIP_CLASS_BY_SIMILARITY_TYPE[similarityType]}
          >
            {badgeLabel}
          </Typography>
        )}
      </HStack>
    </div>
  );
};

export default BcrReviewFieldRow;
